import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import Table, { buttonsStyle } from "../../../components/tables/table";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import {
  getAcuerdoColaboracion,
  deleteAcuerdoColaboracion,
  changeStatusAcuerdoColaboracion,
  changeOrderAcuerdoColaboracion,
} from "../../../../api/acuerdoColaboracion";
import { Button, Tooltip, Switch, FormControlLabel } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import AddIcon from "@material-ui/icons/Add";
import { Autorenew as FilterOffIcon } from "@material-ui/icons";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { useHistory } from "react-router-dom";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import { shallowEqual, useSelector } from "react-redux";
import {
  KeyboardArrowDown,
  KeyboardArrowUp,
} from "@material-ui/icons";
import { SERVER_URL } from "../../../../api";
import { getNonEmpty } from "../../../../utils/helpers";

function getData(acuerdoColaboracion) {
  let data = [];
  for (let i = 0; i < acuerdoColaboracion.length; ++i) {
    const elem = {};
    elem.titulo = getNonEmpty(acuerdoColaboracion[i].titulo);
    elem.logo = acuerdoColaboracion[i].logo || "";
    elem.order = acuerdoColaboracion[i].order || 0;
    elem.id = acuerdoColaboracion[i]._id;
    elem.active = acuerdoColaboracion[i].active;
    data = data.concat(elem);
  }
  data.sort((a, b) => a.order - b.order);
  return data;
}

const initialFilters = {
  active: false,
};

export default function AcuerdoColaboracionPage() {
  const [data, setData] = useState([]);
  const [acuerdoColaboracionId, setAcuerdoColaboracionId] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [filterOptions, setFilterOptions] = useState(initialFilters);
  const history = useHistory();
  const user = useSelector((store) => store.authentication?.user, shallowEqual);
  const [refreshOrder, setRefreshOrder] = useState(false);

  useEffect(() => {
    setRefreshOrder(false);
  }, [refreshOrder]);

  async function cambiarOrden(cell, newOrder) {
    await changeOrderAcuerdoColaboracion(cell, newOrder);
  }
  function buttonFormatter(cell) {
    const elem = data.find((item) => item._id === cell);
    const handleSubtract = () => {
      setData((prevFilteredData) => {
        const currentAcuerdoColaboracion = prevFilteredData.find(
          (acuerdoColaboracion) => acuerdoColaboracion._id === cell
        );
        if (!currentAcuerdoColaboracion || currentAcuerdoColaboracion.order === 0)
          return prevFilteredData;

        const newOrder = currentAcuerdoColaboracion.order - 1;
        cambiarOrden(currentAcuerdoColaboracion._id, newOrder);

        const acuerdoColaboracionToSwap = prevFilteredData.find(
          (acuerdoColaboracion) => acuerdoColaboracion.order === newOrder
        );

        return prevFilteredData.map((acuerdoColaboracion) => {
          if (acuerdoColaboracion._id === cell) {
            return { ...acuerdoColaboracion, order: newOrder };
          }
          if (acuerdoColaboracionToSwap && acuerdoColaboracion._id === acuerdoColaboracionToSwap._id) {
            return { ...acuerdoColaboracion, order: currentAcuerdoColaboracion.order };
          }
          return acuerdoColaboracion;
        });
      });
      setRefreshOrder(true);
    };

    const handleAdd = () => {
      setData((prevFilteredData) => {
        const currentAcuerdoColaboracion = prevFilteredData.find(
          (acuerdoColaboracion) => acuerdoColaboracion._id === cell
        );
        if (
          !currentAcuerdoColaboracion ||
          currentAcuerdoColaboracion.order === prevFilteredData.length - 1
        )
          return prevFilteredData;

        const newOrder = currentAcuerdoColaboracion.order + 1;
        cambiarOrden(currentAcuerdoColaboracion._id, newOrder);
        const acuerdoColaboracionToSwap = prevFilteredData.find(
          (acuerdoColaboracion) => acuerdoColaboracion.order === newOrder
        );

        return prevFilteredData.map((acuerdoColaboracion) => {
          if (acuerdoColaboracion._id === cell) {
            return { ...acuerdoColaboracion, order: newOrder };
          }
          if (acuerdoColaboracionToSwap && acuerdoColaboracion._id === acuerdoColaboracionToSwap._id) {
            return { ...acuerdoColaboracion, order: currentAcuerdoColaboracion.order };
          }
          return acuerdoColaboracion;
        });
      });
      setRefreshOrder(true);
    };

    return (
      <>
        <Tooltip title={"Up"}>
          <Button
            style={buttonsStyle}
            size="small"
            onClick={handleSubtract}
            disabled={elem?.order === 0}
          >
            <KeyboardArrowUp />
          </Button>
        </Tooltip>
        <Tooltip title={"Down"}>
          <Button
            style={buttonsStyle}
            size="small"
            onClick={handleAdd}
            disabled={elem?.order === data.length - 1}
          >
            <KeyboardArrowDown />
          </Button>
        </Tooltip>
        <Tooltip title="Edit">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => history.push("/edit-acuerdo-colaboracion/" + cell)}
          >
            <EditIcon />
          </Button>
        </Tooltip>
        {(user?.role === "admin" || user.role === "gestor") && (
          <>
            <Tooltip title={elem?.active ? "Disable" : "Enable"}>
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setAcuerdoColaboracionId(elem);
                  setOpenConfirmDialog(1);
                }}
              >
                {elem?.active ? (
                  <ToggleOffIcon />
                ) : (
                  <ToggleOnIcon style={{ color: "red" }} />
                )}
              </Button>
            </Tooltip>
            <Tooltip title="Delete">
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setAcuerdoColaboracionId(cell);
                  setOpenConfirmDialog(2);
                }}
              >
                <DeleteIcon />
              </Button>
            </Tooltip>
          </>
        )}
      </>
    );
  }

  function imageFormatter(logo) {
    let src = logo ? `${SERVER_URL}/${logo}` : "";
    return logo ? <img src={src} width={100} height={60} style={{ objectFit: "contain" }} alt="Logo"></img> : <div></div>;
  }

  const columns = [
    {
      dataField: "logo",
      text: "Logo",
      formatter: imageFormatter,
    },
    { dataField: "titulo", text: "Título", sort: true },
    { dataField: "order", text: "Orden", sort: true },
    { dataField: "id", text: "", formatter: buttonFormatter },
  ];

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await getAcuerdoColaboracion();
        if (res.status === 200) {
          setData(res.data);
          setFilteredData(res.data);
          setRefresh(false);
        }
      } catch (error) {
        alertError({
          error: error,
          customMessage: "No se pudieron obtener los acuerdos de colaboración.",
        });
        history.push("/dashboard");
      }
    };
    fetch();
  }, [refresh, history]);

  const handleSearch = async () => {
    if (!data.length) return;
    setFilteredData(
      data.filter((item) => {
        let filter = true;
        if (filterOptions.active) filter = filter && item.active;
        if (filter) return item;
        return false;
      })
    );
  };

  const handleClearFilters = () => {
    setFilterOptions(initialFilters);
    setRefresh(true);
  };

  const renderFiltersContent = () => {
    return (
      <div style={{ padding: "15px 0 0 0" }}>
        {/* Switches y botones de acción en la misma línea */}
        <div className="row">
          <div className="col-12">
            <div className="d-flex justify-content-between align-items-center flex-wrap" style={{ marginTop: "10px", marginBottom: "10px", gap: "15px" }}>
              {/* Switches a la izquierda */}
              <div className="d-flex align-items-center flex-wrap" style={{ gap: "30px" }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={filterOptions.active}
                      onChange={() =>
                        setFilterOptions({
                          ...filterOptions,
                          active: !filterOptions.active,
                        })
                      }
                      name="checkActive"
                      style={{ color: "#f3691a" }}
                    />
                  }
                  label={filterOptions.active ? "Solo activos" : "Todos (activos/inactivos)"}
                  style={{ margin: 0 }}
                />
              </div>
              {/* Botones a la derecha */}
              <div className="d-flex">
                <Button
                  variant="contained"
                  onClick={handleSearch}
                  startIcon={<SearchIcon />}
                  style={{ 
                    minWidth: "120px",
                    backgroundColor: "#f3691a",
                    color: "#fff",
                    marginRight: "10px"
                  }}
                >
                  Buscar
                </Button>
                <Button
                  variant="outlined"
                  onClick={handleClearFilters}
                  startIcon={<FilterOffIcon />}
                  style={{ 
                    minWidth: "120px",
                    borderColor: "#f3691a",
                    color: "#f3691a"
                  }}
                >
                  Limpiar
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <Card>
        <CardHeader title="Lista de Acuerdos de Colaboración">
          <CardHeaderToolbar>
            <Button
              variant="contained"
              onClick={() => history.push("/edit-acuerdo-colaboracion")}
              startIcon={<AddIcon />}
              style={{
                backgroundColor: "#f3691a",
                color: "#fff",
              }}
            >
              Añadir nuevo
            </Button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          {/* Filtros siempre visibles con mejor diseño */}
          <Card style={{ marginBottom: "15px", backgroundColor: "#f8f9fa" }}>
            <CardBody style={{ padding: "15px 20px" }}>
              {renderFiltersContent()}
            </CardBody>
          </Card>

          {!refresh && !refreshOrder && (
            <Table data={getData(data)} columns={columns} />
          )}

          <ConfirmDialog
            title={`¿Estás seguro de que quieres ${
              acuerdoColaboracionId?.active ? "desactivar" : "activar"
            } este acuerdo de colaboración?`}
            open={openConfirmDialog === 1}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              changeStatusAcuerdoColaboracion(acuerdoColaboracionId._id, !acuerdoColaboracionId?.active)
                .then((res) => {
                  if (res.status === 200) {
                    alertSuccess({
                      title: `${
                        acuerdoColaboracionId?.active ? "Desactivado!" : "Activado!"
                      }`,
                      customMessage: `Acuerdo de colaboración ${
                        acuerdoColaboracionId?.active ? "desactivado" : "activado"
                      } correctamente`,
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: `No se pudo ${
                      acuerdoColaboracionId?.active ? "desactivar" : "activar"
                    } el acuerdo de colaboración.`,
                  });
                });
            }}
          />
          <ConfirmDialog
            title={"¿Estás seguro de que quieres eliminar este acuerdo de colaboración?"}
            open={openConfirmDialog === 2}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteAcuerdoColaboracion(acuerdoColaboracionId)
                .then((res) => {
                  if (res.status === 204 || res.status === 200) {
                    alertSuccess({
                      title: "Eliminado!",
                      customMessage: "Acuerdo de colaboración eliminado correctamente.",
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "No se pudo eliminar el acuerdo de colaboración.",
                  });
                });
            }}
          />
        </CardBody>
      </Card>
    </>
  );
}